<app-public-layout
[displayHeader]="!authenticated">
    <app-public-page>
        <app-not-allowed-content></app-not-allowed-content>
    </app-public-page>
</app-public-layout>
